import "/builds/private/pd-ssr/www/js/libs/jqueryui/1.11.0/jquery-ui.min.js"
import "/builds/private/pd-ssr/www/css/libs/jqueryui/1.11.0/themes/smoothness/jquery-ui.css"